import { ref } from 'vue';

const cashTransferRequestModel = ref({
	orderType: null,
	accountOwnerFirstLine: null,
	accountOwnerSecondLine: null,
	accountNumber: null,
	titleFirstLine: null,
	titleSecondLine: null,
	titleThirdLine: null,
	titleFourthLine: null,
	amount: null,
	messageFirstLine: null,
	messageSecondLine: null,
	messageThirdLine: null,
	transactionCode: null,
	outputCode: null,
	dischargeSignal: null,
	inspected: null
});

const orderDetailsModel = ref({
	taxNumber: null,
	name: null,
	phone: null,
	orderAmount: null,
	format: null,
	mailingName: null,
	postalCode: null,
	city: null,
	addressDetails: null,
	gdprAccepted: null
});

const getCashTransferRequestModel = () => {
	return ref({ ...cashTransferRequestModel.value });
};
const getOrderDetailsModel = () => {
	return ref({ ...orderDetailsModel.value });
};
const getOrderType = () => {
	return cashTransferRequestModel.value.orderType;
};
const setCashTransferRequestModel = (model) => {
	cashTransferRequestModel.value = model.value;
};
const setOrderDetailsModel = (model) => {
	orderDetailsModel.value = model.value;
};

export const useStore = () => {
	return {
		getCashTransferRequestModel,
		getOrderDetailsModel,
		getOrderType,
		setCashTransferRequestModel,
		setOrderDetailsModel
	};
};
